

export const BANNER_CLASS_NAME = 'nr-b';
